import { Injectable } from '@angular/core';
import {NavController, Platform} from '@ionic/angular';
import {DeviceType, NavigationDirection, NavigationPage} from '@interfaces/common/common.interface';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private previousUrl = '';

  constructor(private platform: Platform,
              private router: Router,
              private navCtrl: NavController) {
    // Recorded on NavigationStart, where router.url is still the route being
    // left and which runs before route activation - and so before the landing
    // page's ionViewWillEnter.
    this.router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe(() => this.previousUrl = this.router.url.split('?')[0]);
  }

  /**
   * @name isReturningFrom()
   * @description True when the navigation now landing started from a sub-route
   * of baseRoute, e.g. coming back to /exchange-mapping from
   * /exchange-mapping/edit/1. The trailing slash keeps a sibling route such as
   * /exchanges from matching /exchange-mapping, and leaves a cold load - where
   * there is no previous route - reading as false.
   */
  public isReturningFrom(baseRoute: string): boolean {
    return this.previousUrl.startsWith(`${baseRoute}/`);
  }

  public getCurrentRoute() {
    const fullRoute = this.router.url.split('?')[0];
    const device = fullRoute.split('/')[1];
    if (device !== 'mobile' && device !== 'tablet') {
      return {device, route: fullRoute.substring(1)};
    } else {
      const route = fullRoute.split('/');
      route.splice(1, 1);
      return {device, route: route.join('/').substring(1)};
    }
  }

  public async goTo(page: NavigationPage, direction: NavigationDirection = 'forward',
                    animated: boolean = true, params: any = null): Promise<any> {
      let uri = `${page}`;
      if (params) {
        uri = `${page}/${params}`;
      }
      switch (direction) {
        case 'forward':
          this.navCtrl.navigateForward(uri, {animated}).then(() => true);
          break;
        case 'backward':
          await this.navCtrl.navigateBack(uri, {animated}).then(() => true);
          break;
        case 'root':
        default:
          await this.navCtrl.navigateRoot(uri, {animated}).then(() => true);
      }
  }
}
